import * as React from "react";
export class PulseLoading extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-pulse-bet-markets__pulse-loading" }));
    }
}
//# sourceMappingURL=PulseLoading.js.map